import React from "react";
import { LaunchNavigator } from "uk.co.workingedge.phonegap.plugin.launchnavigator";
import { STRINGS } from "../../../strings";
import { translate } from "../../../translate";
import { assertUndefinedable } from "../../../utils/assertUndefinedable";
import { AppBottomSheet } from "../../Generic/AppBottomSheet";
import { AppBoxActionCard } from "../../Generic/AppBoxActionCard";
import { AppBoxActionCards } from "../../Generic/AppBoxActionCards";
import { AppOverlay } from "../../Generic/AppOverlay";
import { If } from "../../Generic/If";

const ICONS: { [key: string]: string | undefined } = {
  waze: "assets/waze-icon.svg",
  google_maps: "assets/google-maps-icon.svg",
  apple_maps: "assets/apple-maps-icon.svg",
  uber: "assets/uber-icon.svg",
};

interface Props {
  isOpen: boolean;
  destination: string | number[] | null;
  onRequestClose: () => void;
}

const launchnavigator = (window as any).launchnavigator as LaunchNavigator;

const DirectionsBottomSheet = (props: Props) => {
  const [apps, setApps] = React.useState<string[]>([]);

  React.useEffect(() => {
    if ("launchnavigator" in window) {
      if (assertUndefinedable(launchnavigator.availableApps) !== undefined) {
        launchnavigator.availableApps((result: { [key: string]: boolean }) => {
          const keys = Object.keys(result);
          setApps(keys.filter((key) => result[key]));
        });
      }
    }
  }, []);

  const handleChooseApp = (app: string) => {
    if (props.destination !== null) {
      launchnavigator.navigate(props.destination, { app: app });
    }
  };

  return (
    <AppOverlay>
      <AppBottomSheet isOpen={props.isOpen} onRequestClose={props.onRequestClose}>
        <AppBoxActionCards>
          <If condition={props.destination === null || apps.length === 0}>
            <AppBoxActionCard
              className="Soft"
              icon={<div className="PlaceholderIcon" />}
              label={translate(STRINGS.PLEASE_CONTACT_YOUR_AGENCY_FOR_AN_ADDRESS)}
              onClick={() => {
                /* DO NOTHING */
              }}
            />
          </If>
          <If condition={props.destination !== null}>
            {apps.map((app) => (
              <AppBoxActionCard
                key={app}
                icon={
                  ICONS[app] !== undefined ? (
                    <img src={ICONS[app]} />
                  ) : (
                    <div className="PlaceholderIcon" />
                  )
                }
                label={launchnavigator.getAppDisplayName(app)}
                onClick={() => handleChooseApp(app)}
              />
            ))}
          </If>
        </AppBoxActionCards>
      </AppBottomSheet>
    </AppOverlay>
  );
};

export default React.memo(DirectionsBottomSheet);
